import { get } from '@/api/base'

export default {
  getAll: async () => {
    const response = await get({ path: 'containers/type_group_names' })

    return response.success ? response.data : response
  },
}
